import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Grid,
  Box,
  Text,
  Divider,
  Stack,
  Link
} from '@chakra-ui/react';
import { useStores } from "../../store/store_context";



const RowDetailModal = ({ isOpen, onClose, item, availableColumns }) => {
  const { pageStore } = useStores();
  if (!item) return null;

  const documentTypes = ['ЗаказКлиента', 'Поступление', 'Списание', 'Реализация', 'Сделка'];
  const columnsDocuments = {
    "ЗаказКлиента": ["Org", "Manager", "Num", "Date", "AccOpenDate", "PlanClosDate", "InvAmount", "Value", "RevRub", "Partner", "IdDeal", "Deal", "PaidEuro", "PaidRub", "PercentPayment", "DeptEuro", "DeptRub", "PercentShipment", "IsReturn"],
    "Поступление": ["DocNum", "DocDate", "DocSum", "DocPresent", "Manager"],
    "Списание": ["DocNum", "DocDate", "DocSum", "DocPresent", "Manager"],
    "Реализация": ["DocNum", "DocDate", "DocSum", "DocPresent", "Manager"],
    "Сделка": ["Num", "Partner", "Deal", "Manager", "IdDeal", "planProfit", "planRent"]
  }

  // 2. Собираем все документы в один плоский массив в зависимости от типа
  let itemsToRender = [];
  if (item.type === 'order-parent') {
    if (item.parent) itemsToRender.push(item.parent);
    if (Array.isArray(item.children)) itemsToRender.push(...item.children);
  } else if (item.type === 'order-child') {
    if (item.item) itemsToRender.push(item.item);
  } else {
    // На случай, если передан обычный документ
    itemsToRender.push(item);
  }

  // 3. Группируем документы по DocType
  const groupedItems = {
    'ЗаказКлиента': [],
    'Списание': [],
    'Поступление': [],
    'Реализация': [],
    'Сделка': []
  };

  itemsToRender.forEach(doc => {
    if (doc && doc.DocType && groupedItems[doc.DocType]) {
      groupedItems[doc.DocType].push(doc);
    }
  });

  // Функция для красивого отображения ключей (из доступных колонок или просто ключ)
  const getLabel = (key) => {
    const column = pageStore.columnConfigPDZ?.find(c => c.key === key);
    return column ? column.title : key;
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="full" scrollBehavior="inside">
      <ModalOverlay backdropFilter="blur(4px)" />
      <ModalContent bg="#1A202C" color="white" borderRadius="none">

        <ModalHeader borderBottomWidth="1px" borderColor="#2D3748" px={6}>
          Детали цепочки документов
        </ModalHeader>
        <ModalCloseButton />

        <ModalBody py={6} px={6}>
          {/* Сетка на 4 колонки для больших экранов */}
          <Grid templateColumns={{ base: "1fr", xl: "repeat(4, 1fr)" }} gap={6} alignItems="start">

            {documentTypes.map(type => (
              <Box key={type} bg="#222B36" p={4} borderRadius="lg" border="1px solid #4A5568" minH="50vh">
                {/* Заголовок столбца */}
                <Text fontSize="xl" fontWeight="bold" color="white" mb={4} borderBottom="1px solid #4A5568" pb={2} textAlign="center">
                  {type}
                </Text>

                {groupedItems[type].length === 0 ? (
                  <Text color="gray.500" fontSize="sm" textAlign="center">Нет документов</Text>
                ) : (
                  <Stack spacing={4}>
                    {groupedItems[type].map((doc, idx) => (
                      // Карточка конкретного документа в столбце
                      <Box key={idx} p={4} bg="#1A202C" borderRadius="md" border="1px solid #2D3748">
                        {/* Опционально: можно вывести номер документа сверху для наглядности */}
                        {doc.DocNum && (
                          <Text fontWeight="bold" color="blue.300" mb={2} borderBottom="1px solid #2D3748" pb={1}>
                            № {doc.DocNum}
                          </Text>
                        )}

                        <Grid templateColumns="1fr" gap={2}>
                          {Object.entries(doc).map(([key, value]) => {
                            if (typeof value === 'object' && value !== null) return null;
                            if (value == null || value == 0) return null;
                            if (!columnsDocuments[type].includes(key)) return null;

                            return (
                              <Box key={key} p={2} _hover={{ bg: "#2D3748" }} borderRadius="md" transition="0.2s">
                                <Text fontWeight="bold" color="orange.300" fontSize="xs" textTransform="uppercase">
                                  {getLabel(key)}
                                </Text>
                                {type == "Сделка" && (key == "IdDeal" || key == "Deal") ?
                                  <Link
                                    href={"https://alforest.bitrix24.ru/crm/deal/details/{value}/".replace("{value}", doc['IdDeal'])}
                                    isExternal
                                    textDecoration={"underline"}
                                    color="white"
                                    _hover={{ color: "blue.500" }}
                                  >
                                    {typeof value === 'number' ? value.toLocaleString('ru-RU') : String(value ?? '—')}
                                  </Link>
                                  :
                                  <Text fontSize="sm" mt={1}>
                                    {typeof value === 'number' ? value.toLocaleString('ru-RU') : String(value ?? '—')}
                                  </Text>
                                }
                              </Box>
                            );
                          })}
                        </Grid>
                      </Box>
                    ))}
                  </Stack>
                )}
              </Box>
            ))}

          </Grid>
        </ModalBody>

        <ModalFooter borderTopWidth="1px" borderColor="#2D3748" px={6}>
          <Button colorScheme="blue" onClick={onClose}>
            Закрыть
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default RowDetailModal;